import { UntypedFormControl } from '@angular/forms';

export const createFormControl = (name: string, value: any, validators?: any): UntypedFormControl => {
  if (!validators) { return new UntypedFormControl(value); }
  const validator = (<any>validators)[name];
  return validator ? new UntypedFormControl(value, validator) :  new UntypedFormControl(value);
};
